// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d1969f95","732":"3e7fc4b7","977":"6325c4f3"}[chunkId] + ".chunk.js";
};